import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=dcf6a628&scoped=true&"
import script from "./FileField.vue?vue&type=script&lang=ts&"
export * from "./FileField.vue?vue&type=script&lang=ts&"
import style0 from "./FileField.vue?vue&type=style&index=0&id=dcf6a628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf6a628",
  null
  
)

export default component.exports